module.exports = __webpack_public_path__ + "static/img/Platform_design1.57e24a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Platform_design1.png
// module id = Ujzx
// module chunks = 0